const SESSION_RECORDING_EVENTS = Object.freeze({
  incentiveOfferClick: "snow_incentive_offer_click",
  incentiveContinueClick: "snow_incentive_continue_click",
  incentivePanelClick: "snow_incentive_panel_click",
  signupNoFreeClick: "snow_signup_no_free_click",
  subPopupOpened: "snow_sub_popup_opened",
  subPopupReading: "snow_sub_popup_reading",
  subPopupInteraction: "snow_sub_popup_interaction",
  subPopupEngagementDummy: "snow_sub_popup_engagement_dummy",
  subEntryLoggedIn: "snow_sub_entry_logged_in",
  subEntryAnon: "snow_sub_entry_anon",
  subConfirmationViewed: "snow_sub_confirmation_viewed",
  subCheckoutStarted: "snow_sub_checkout_started",
  subPaymentSuccess: "snow_sub_payment_success",
})

export default SESSION_RECORDING_EVENTS
